export default __webpack_public_path__ + "static/client2-f0e867253477d3999410ad072b694dbe.jpg";